import { render, staticRenderFns } from "./RelatorioRupturaListFiltro.vue?vue&type=template&id=72cc7607"
import script from "./RelatorioRupturaListFiltro.vue?vue&type=script&lang=js"
export * from "./RelatorioRupturaListFiltro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports